export const GET_CONTACT_NOTES = "GET_CONTACT_NOTES";
export const RESET_CONTACT_NOTES = "RESET_CONTACT_NOTES";
export const SET_CONTACT_NOTES_REQUEST_STATUS = "SET_CONTACT_NOTES_REQUEST_STATUS";
